<style>
.summary-company-select-ul li label input[type="checkbox"] {
    position: absolute;
    top: 10px;
    right: 15px;
}
.summary-company-select-ul li label input[type="checkbox"]:after{
	content: url(../assets/allorderbill/uncheck.png);
}
.summary-company-select-ul li label input[type="checkbox"]:checked:after{
	content: url(../assets/allorderbill/check.png);
}
</style>
<template>
<div>
<transition name="slide">
	<div v-show="show" class="summary-wrapper">
		<a class="bill-filter-cancel" @click="cancel">取消</a>
		<nav class="edi-nav">{{title}}</nav>
		<div class="summary-filter-shell">
			<ul class="summary-filter-ul summary-company-select-ul">
				<li v-for="status in statusList" :key="status.stateValue">
					<label>{{status.stateFont}}
						<input @change="status.stateValue === 'all' ? selectAll() : selectBillStatus(status.stateValue, status.stateFont)" type="checkbox" name="selectBillStatus" v-model="status.checked">
					</label>
				</li>
				<!-- <li>
					<label>全选
						<input @change="selectAll" type="checkbox" v-model="isAll">
					</label>
				</li> -->
				<!-- <li>
				<label>待发货
					<input @click.self="selectBillStatus('11', '待发货')" type="checkbox" name="selectBillStatus" v-if="selectJudge('11')" checked>
					<input @click.self="selectBillStatus('11', '待发货')" type="checkbox" name="selectBillStatus" v-else>
				</label></li>
				<li><label>已发货
					<input @click.self="selectBillStatus('12', '已发货')" type="checkbox" name="selectBillStatus" v-if="selectJudge('12')" checked>
					<input @click.self="selectBillStatus('12', '已发货')" type="checkbox" name="selectBillStatus" v-else>
				</label></li>
				<li>
				<label>已收货
					<input @click.self="selectBillStatus('13', '已收货')" type="checkbox" name="selectBillStatus" v-if="selectJudge('13')" checked>
					<input @click.self="selectBillStatus('13', '已收货')" type="checkbox" name="selectBillStatus" v-else>
				</label>
				</li> -->
			</ul>
			<a class="summary-filter-btn" @click="confirm">确定</a>
		</div>
	</div>
</transition>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		title: String,
		billStatusFlag: String,
		billStatusFont: String,
		statusList: {
			type: Array,
			default: () => {
				return [{
					stateValue: '10',
					stateFont: '未处理',
					checked: false
				}, {
					stateValue: '11',
					stateFont: '待发货',
					checked: false
				}, {
					stateValue: '12',
					stateFont: '已发货',
					checked: false
				}, {
					stateValue: '13',
					stateFont: '已收货 待确认',
					checked: false
				}, {
					stateValue: '14,15,16,17',
					stateFont: '已收货 已确认',
					checked: false
				}]
			}
		}
	},
	data () {
		return {
			show: false,
			arr: [],
			arr2: [],
			arr3: []
			// isAll: false
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {
		this.arr3 = this.billStatusFlag.split(',')
	},
	methods: {
		stopFalse () {
			return false
		},
		selectJudge (val) {
			if (this.arr3.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		},
		open (flag, font) {
			this.arr3 = flag
			// window.console.log(this.billStatusFlag)
			this.show = !this.show
			this.arr = []
			this.arr2 = []
			this.arr = flag.split(',')
			this.arr2 = font.split(',')
			if (this.arr[0] === '') {
				this.arr = []
			}
			if (this.arr2[0] === '') {
				this.arr2 = []
			}
			if (this.arr2[0] === '全选') {
				this.arr2.length = 0
				let statusNotAll = this.statusList.filter(item => {
					return item.stateValue !== 'all'
				})
				statusNotAll.forEach(item => {
					this.arr2.push(item.stateFont)
				})
			}
			this.statusList.forEach(item => {
				item.checked = false
				if (this.arr3.indexOf(item.stateValue) !== -1) {
					item.checked = true
				}
			})
			this.doAllCheck()
		},
		selectBillStatus (val1, val2) {
			val1.split(',').forEach(item => {
				var index = this.arr.indexOf(item)
				if (index === -1) {
					this.arr.push(item)
					this.arr2.push(val2)
				} else {
					this.arr.splice(index, 1)
					this.arr2.splice(index, 1)
				}
				this.doAllCheck()
			})
		},
		// 除了全选都选中 就把全选选中 有一个未选中 就把选中去掉
		doAllCheck: function () {
			let statusNotAll = this.statusList.filter(item => {
				return item.stateValue !== 'all'
			})
			let isAll = statusNotAll.every(item => {
				return item.checked === true
			})
			this.statusList.find(item => {
				if (item.stateValue === 'all') {
					item.checked = isAll
					if (isAll) {
						this.arr2 = [item.stateFont]
					}
				}
			})
		},
		// 全选
		selectAll () {
			var selectAll = this.statusList.filter(item => {
				return item.stateValue === 'all'
			})
			this.statusList.forEach(item => {
				item.stateValue.split(',').forEach(x => {
					var index = this.arr.indexOf(x)
					if (selectAll[0].checked) {
						item.checked = true
						if (index === -1 && item.stateValue !== 'all') {
							this.arr.push(x)
							// this.arr2.push(item.stateFont)
						} else if (item.stateValue === 'all') {
							this.arr2 = [item.stateFont]
						}
					} else {
						item.checked = false
						if (index !== -1) {
							this.arr.splice(index, 1)
							this.arr2.splice(index, 1)
						}
					}
				})
			})
		},
		confirm () {
			this.show = false
			let statusAll = this.statusList.filter(item => {
				return item.stateValue === 'all'
			})
			if (statusAll.length > 0) {
				this.arr2 = []
				if (statusAll[0].stateValue === 'all' && statusAll[0].checked) {
					this.arr2 = [statusAll[0].stateFont]
				} else {
					this.statusList.forEach(item => {
						if (item.stateValue !== 'all') {
							var index = this.arr.indexOf(item.stateValue.split(',')[0])
							if (index !== -1 && item.stateValue !== 'all') {
								this.arr2.push(item.stateFont)
							}
						}
					})
				}
			} else {
				let isAll = this.statusList.every(item => {
					return item.checked === true
				})
				if (isAll) {
					this.arr2 = ['全选']
				}
			}
			var msg = [this.arr, this.arr2]
			this.$emit('confirm', msg)
		},
		cancel () {
			this.show = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillStatusSelectM.vue?4529957c